export default __webpack_public_path__ + "static/media/my-library-blue.ba3351d5.svg";